/**
 * Create Addresses context for custom hook
 */

import { createContext } from 'react'

const AddressesContext = createContext({
  countryCallingCodes: [],
  fetchCountries: () => {},
  fetchStatesCitiesDistricts: () => {},
  fetchStreet: () => {},
  fetchZip: () => {}
})

export default AddressesContext
